import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { Project, ConsultantResource, Objective, ProjectService, Activity, ActivityConsultantResource, ProjectResource } from 'toolbandi-ui-lib';
import { CrudService, MessageService } from 'elbuild-ui-lib-core';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, forkJoin } from 'rxjs';
import { ProjectConsultantsAddComponent } from './project-consultants-add/project-consultants-add.component';
import * as screenfull from 'screenfull';

@Component({
	selector: 'app-project-consultants',
	templateUrl: './project-consultants.component.html',
	styleUrls: ['./project-consultants.component.scss']
})

export class ProjectConsultantsComponent implements OnInit {

	@Input()
	projectid: number;
	project: Project;
	@Input()
	consultantid: number;

	resources: ConsultantResource[];
	objectives: Objective[];
	loading: boolean;

	@ViewChild('tablearea', { static: true }) tablearea: ElementRef;
	tablefull: boolean;


	inputValue = {};
	activities: any;


	constructor(
		private objectiveService: CrudService<Objective>,
		private activityService: CrudService<Activity>,
		private projectService: ProjectService,
		private messageService: MessageService,
		private translateService: TranslateService,
		private modalService: NgbModal,
		private projectCrudService: CrudService<Project>,
		private resService: CrudService<ActivityConsultantResource>

	) { }

	ngOnInit() {
		if (this.projectid) {
			this.load();
			this.projectCrudService.getEntity(Project, 'project', this.projectid).subscribe((p: Project) => this.project = p);
		}

	}

	load() {

		this.loading = true;
		const requests: Observable<any>[] = [];

		requests.push(this.objectiveService.getFiltered(Objective, 'objective', 'projectid', this.projectid + ''));
		requests.push(this.projectService.getActivityConsultantResourceMatrix(this.projectid, this.consultantid));
		requests.push(this.activityService.countFiltered(Activity, 'activity', 'projectid', this.projectid + ''));

		forkJoin(requests).subscribe(data => {
			this.objectives = data[0];
			this.resources = data[1];
			this.activities = data[2];
			this.initInputValues();
			this.loading = false;
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
			this.loading = false;
		});


	}

	initInputValues(): void {
		for (const r of this.resources) {
			for (const m of r.projectactivities) {
				this.inputValue['a' + m['activityid'] + 'r' + m['consultresid'] + '-in'] = m['inhr'];
				this.inputValue['a' + m['activityid'] + 'r' + m['consultresid'] + '-out'] = m['outhr'];
			}
		}
	}

	toggleFullscreen() {
		const s = screenfull as screenfull.Screenfull;
		if (this.tablefull) {

			if (s.isFullscreen) {
				s.exit();
				this.tablefull = false;
			}
		} else {
			if (s.enabled && this.tablearea && this.tablearea.nativeElement) {
				s.toggle(this.tablearea.nativeElement);
				this.tablefull = true;
			}
		}

	}

	add(): void {

		const modal = this.modalService.open(ProjectConsultantsAddComponent, {
			centered: true,
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});

		modal.componentInstance.projectid = this.projectid;
		if (this.consultantid) {
			modal.componentInstance.consultantid = this.consultantid;
		}

		modal.componentInstance.reload();


		modal.result.then(() => {
			this.load();
		}).catch(() => {
			this.load();
		});

	}

	toggle(a: Activity, res: ConsultantResource, field: number) {
		// field : 0 --> in, 1 --> out

		if (!(this.project.isDraft)) {
			return;
		}

		if (a && res) {
			let activityres = res.getActivityRes(a.id);

			if (!activityres) {
				activityres = new ActivityConsultantResource();
				activityres.activityid = a.id;
				activityres.consultresid = res.id;
			}

			if (field) {
				activityres.outhr = this.inputValue['a' + a.id + 'r' + res.id + '-out'];
			} else {
				activityres.inhr = this.inputValue['a' + a.id + 'r' + res.id + '-in'];
			}

			if (activityres.id && !activityres.inhr && !activityres.outhr) {
				this.resService.deleteEntity(ActivityConsultantResource, 'activityconsultantresource', activityres).subscribe(() => {
					res.removeActivity(activityres.id);
				});
			} else {
				if (activityres.id) {

					this.resService.saveEntity(ActivityConsultantResource, 'activityconsultantresource', activityres).subscribe(activity => {
						res.addActivity(activity);
					}, ({ error }) => {
						this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));

					});
				} else {
					this.resService.createEntity(ActivityConsultantResource, 'activityconsultantresource', activityres).subscribe(activity => {
						res.addActivity(activity);
					}, ({ error }) => {
						this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));

					});
				}
			}
		}
	}
}



